var _Ctx_container, _Ctx_clock;
import { __awaiter, __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
/**
 * The ctx object that can be accessed in plugin and action.
 */
export class Ctx {
    constructor(container, clock) {
        _Ctx_container.set(this, void 0);
        _Ctx_clock.set(this, void 0);
        /**
         * Get the slice instance.
         *
         * @param slice - The slice needs to be used.
         * @returns The slice instance.
         */
        this.use = (slice) => __classPrivateFieldGet(this, _Ctx_container, "f").getSlice(slice);
        /**
         * Get the slice value.
         *
         * @param slice - The slice needs to be used.
         * @returns The slice value.
         */
        this.get = (slice) => this.use(slice).get();
        /**
         * Set the slice value.
         *
         * @param slice - The slice needs to be used.
         * @returns
         */
        this.set = (slice, value) => this.use(slice).set(value);
        /**
         * Update the slice by it's current value.
         *
         * @example
         * ```
         * update(NumberSlice, x => x + 1);
         * ```
         *
         * @param slice - The slice needs to be used.
         * @param updater - The update function, gets current value as parameter and returns new value.
         * @returns
         */
        this.update = (slice, updater) => this.use(slice).update(updater);
        /**
         * Get the timer instance.
         *
         * @param timer - The timer needs to be used.
         * @returns The timer instance.
         */
        this.timing = (timer) => __classPrivateFieldGet(this, _Ctx_clock, "f").get(timer);
        /**
         * Wait for a timer to finish.
         *
         * @param timer - The timer needs to be used.
         * @returns A promise that will be resolved when timer finish.
         */
        this.wait = (timer) => this.timing(timer)();
        /**
         * Finish a timer
         *
         * @param timer - The timer needs to be finished.
         * @returns
         */
        this.done = (timer) => this.timing(timer).done();
        /**
         * Wait for a list of timers in target slice to be all finished.
         *
         * @param slice - The slice that holds a list of timer.
         * @returns A promise that will be resolved when all timers finish.
         */
        this.waitTimers = (slice) => __awaiter(this, void 0, void 0, function* () {
            yield Promise.all(this.get(slice).map((x) => this.wait(x)));
            return;
        });
        __classPrivateFieldSet(this, _Ctx_container, container, "f");
        __classPrivateFieldSet(this, _Ctx_clock, clock, "f");
    }
}
_Ctx_container = new WeakMap(), _Ctx_clock = new WeakMap();
//# sourceMappingURL=ctx.js.map